<template>
  <div class="container mx-auto mb-8">
    <base-form v-if="contact" :do="save" :v-errors="error" class="flex flex-wrap flex-col-reverse justify-center md:flex-row md:-mx-4">

      <div class="w-full md:w-2/3 md:px-4">
        <div name="Contact" class="flex content">
          <div class="w-full bg-white">
            <div class="group">
              <div class="fields flex flex-col w-full p-6">

                <div class="flex flex-wrap mx-0 md:-mx-2">
                  <text-input class="w-full md:w-1/2 md:px-2" label="Naam" name="name" type="text"
                    v-model="contact.name"
                    v-validate="'required'"
                    data-vv-as="Naam"
                    :error="errors.first('name')"
                    :has-permission="true"
                    :required="true"
                  ></text-input>
                  <text-input class="w-full md:w-1/2 md:px-2" label="Telefoon" name="phone" type="text"
                    v-model="contact.phone"
                    v-validate="'numeric'"
                    data-vv-as="Telefoon"
                    :error="errors.first('phone')"
                    :has-permission="true"
                  ></text-input>
                </div>

                <div class="flex flex-wrap mx-0 md:-mx-2">
                  <text-input class="w-full md:w-3/4 md:px-2" label="Straat" name="street" type="text"
                    v-model="contact.street"
                    v-validate="'alpha_spaces'"
                    data-vv-as="Straat"
                    :error="errors.first('street')"
                    :has-permission="true"
                  ></text-input>
                  <text-input class="w-full md:w-1/4 md:px-2" label="Huisnummer" name="house_number" type="text"
                    v-model="contact.house_number"
                    :has-permission="true"
                  ></text-input>
                </div>

                <div class="flex flex-wrap mx-0 md:-mx-2">
                  <text-input class="w-full md:w-1/2 md:px-2" label="Postcode" name="postal_code" type="text"
                    v-model="contact.postal_code"
                    :has-permission="true"
                  ></text-input>
                  <text-input class="w-full md:w-1/2 md:px-2" label="Stad" name="city" type="text"
                    v-model="contact.city"
                    v-validate="'alpha_spaces'"
                    data-vv-as="Stad"
                    :error="errors.first('city')"
                    :has-permission="true"
                  ></text-input>
                </div>

                <div class="flex w-full mt-4">
                  <div class="buttons flex justify-end">
                    <button type="submit" class="btn btn-sm bg-green-dark">Opslaan</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col w-full md:w-1/3 px-4" v-if="contact.created_at">
        <!-- CREATED -->
        <div class="w-full rounded mb-4" style="background-color: #e7eef3;">
          <div class="field w-full px-4 pt-4 pb-2">
            <div class="heading mb-2">
              <label class="uppercase tracking-wide text-xs text-grey-dark font-bold" for="">Gemaakt op</label>
            </div>
            <div class="input">
              <span class="block w-full text-sm text-grey-darkest">{{ contact.created_at }}</span>
            </div>
          </div>
          <div class="field w-full px-4 py-2 pt-2 pb-4">
            <div class="heading mb-2">
              <label class="uppercase tracking-wide text-xs text-grey-dark font-bold" for="">Gewijzigd op</label>
            </div>
            <div class="input">
              <span class="block w-full text-sm text-grey-darkest">{{ contact.updated_at }}</span>
            </div>
          </div>
        </div>
      </div>

    </base-form>
    <base-notification
      :type="notification.type"
      :message.sync="notification.message"
    ></base-notification>
  </div>
</template>

<script>
import Contact from '@/store/modules/contact';
import ContactService from '@/services/contact';
import ContactPerimeters from '@/perimeters/contact';

import BaseForm from '@/components/globals/BaseForm';
import BaseNotification from '@/components/globals/BaseNotification';
import TextInput from '@/components/inputs/Text';

import { mapState } from 'vuex';

export default {
  name: 'ContactEdit',
  perimeters: [ContactPerimeters],
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    BaseForm,
    BaseNotification,
    TextInput
  },
  data() {
    return {
      contact: null,
      notification: {
        type: 'info',
        message: ''
      },
      isNew: false
    };
  },
  async created() {
    if (!this.$store.state.contact) {
      this.$store.registerModule('contact', Contact);
    }
    await this.fetchContact();
  },
  computed: {
    ...mapState('contact', ['error'])
  },
  methods: {
    async fetchContact() {
      if (!this.$route.params.id) {
        this.contact = {};
        return (this.isNew = true);
      }

      try {
        const { data: response } = await ContactService.get(
          this.$route.params.id
        );
        this.contact = response.data;
      } catch (error) {
        this.$store.commit('contact/setError', error);
        this.contact = null;
      }
    },
    async save() {
      await this.$store.dispatch('contact/save', this.contact);

      if (this.error) {
        this.notification.type = 'error';
        this.notification.message = 'Contact niet opgeslagen';
        return;
      }

      this.notification.type = 'success';
      this.notification.message = 'Contact opgeslagen';
      return this.$router.push({ name: 'contacts' });
    }
  }
};
</script>
